// Huisronde (0075_huisronde). Handgeschreven zoals notes.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/huisronde.ts); openapi.contract.test.ts bewaakt elke aanroep.
const id = (v) => encodeURIComponent(v);
export function createHuisrondeClient(t) {
    return {
        overview: () => t.request('GET', '/v1/app/huisronde'),
        // zones
        createZone: (name) => t.request('POST', '/v1/app/huisronde/zones', { name }),
        renameZone: (zoneId, name, ifVersion) => t.request('PATCH', `/v1/app/huisronde/zones/${id(zoneId)}`, {
            name,
            if_version: ifVersion,
        }),
        removeZone: (zoneId) => t.request('DELETE', `/v1/app/huisronde/zones/${id(zoneId)}`),
        orderZones: (ids) => t.request('POST', '/v1/app/huisronde/zones/order', { ids }),
        starter: () => t.request('POST', '/v1/app/huisronde/starter', {}),
        // items
        createItem: (input) => t.request('POST', '/v1/app/huisronde/items', input),
        updateItem: (itemId, input) => t.request('PATCH', `/v1/app/huisronde/items/${id(itemId)}`, input),
        removeItem: (itemId) => t.request('DELETE', `/v1/app/huisronde/items/${id(itemId)}`),
        orderItems: (zoneId, ids) => t.request('POST', '/v1/app/huisronde/items/order', { zone_id: zoneId, ids }),
        fromPantry: (zoneId, pantryIds) => t.request('POST', '/v1/app/huisronde/items/from-pantry', {
            zone_id: zoneId,
            pantry_item_ids: pantryIds,
        }),
        // schema en uitstel
        putSchedule: (input) => t.request('PUT', '/v1/app/huisronde/schedule', input),
        snooze: (option, until) => t.request('POST', '/v1/app/huisronde/snooze', until ? { option, until } : { option }),
        // de ronde
        start: (clientOpId) => t.request('POST', '/v1/app/huisronde/runs', clientOpId ? { client_op_id: clientOpId } : {}),
        run: (runId) => t.request('GET', `/v1/app/huisronde/runs/${id(runId)}`),
        check: (runId, input) => t.request('POST', `/v1/app/huisronde/runs/${id(runId)}/check`, input),
        uncheck: (runId, itemId) => t.request('POST', `/v1/app/huisronde/runs/${id(runId)}/uncheck`, {
            item_id: itemId,
        }),
        pause: (runId, zoneId) => t.request('POST', `/v1/app/huisronde/runs/${id(runId)}/pause`, {
            zone_id: zoneId,
        }),
        cancel: (runId) => t.request('POST', `/v1/app/huisronde/runs/${id(runId)}/cancel`, {}),
        finish: (runId, input) => t.request('POST', `/v1/app/huisronde/runs/${id(runId)}/finish`, input),
        clearHistory: () => t.request('DELETE', '/v1/app/huisronde/history'),
    };
}
//# sourceMappingURL=huisronde.js.map